const driversTab = {
  bindings: {
    train: '<',
    topologyUpdatedTime: '<',
    isTrainConnected: '<',
  },
  templateUrl: '/modules/configurationManagement/drivers-tab/drivers-tab.html',
  controller: 'DriversTabController',
};

angular
  .module('configuration-management.module')
  .component('driversTab', driversTab)
  .config(function ($stateProvider) {
    $stateProvider.state('train.driver', {
      url: '/driversdisplay',
      views: {
        'traintab@train': 'driversTab',
      },
      resolve: {
        auth: function (userService, $state, eventService) {
          return userService
            .resolve(['ACCESS_DRIVERS_VIEW'])
            .then(() => {
            })
            .catch(() => {
              eventService.trigger('userservice:unauthorized');
              $state.go('train');
            });
        },
      },
    });
  });
